
import ExerciseService from 'services/exercises.services';
import { actions } from './actionTypes';
import { alertActions } from 'actions/alert.actions';

export const getBrikloListExercise = (
  page: number,
  limit: number,
  name: string = ''
) => {
  return (dispatch: any) => {
    dispatch(actions.getBrikloListExercise());
    ExerciseService.getBrikloListExercise({ page, limit, search: name })
      .then((res: any) => {
        dispatch(actions.getBrikloListExerciseSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.getBrikloListExerciseFail(err));
      });
  };
};


export const getListExercise = (
  page: number,
  limit: number,
  name: string = ''
) => {
  return (dispatch: any) => {
    dispatch(actions.getListExercise());
    ExerciseService.getListExercise({ page, limit, search: name })
      .then((res: any) => {
        dispatch(actions.getListExerciseSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.getListExerciseFail(err));
      });
  };
};

export const getDetailExercise = (
  id: any
) => {
  return (dispatch: any) => {
    dispatch(actions.getDetailExercise());
    ExerciseService.getDetailExercise(id)
      .then((res: any) => {
        dispatch(actions.getDetailExerciseSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.getDetailExerciseFail(err));
      });
  };
};

export const createExercise = (params: any, id?: any) => {
  return async (dispatch: any) => {
    dispatch(actions.createExercise());
    return await ExerciseService.createExercise(params, id)
      .then((res: any) => {
        if(id){
          dispatch(actions.updateExerciseSuccess(res?.data));
          dispatch(alertActions.success(`Exercise has been edited successfully!`));
        }
        else{
          dispatch(actions.createExerciseSuccess(res?.data));
          dispatch(alertActions.success('Exercise has been created successfully!'));
        }
      
        return res;
      })
      .catch((err) => {
        dispatch(actions.createExerciseFail(err));
        dispatch(alertActions.error('Something happened please try again!'));
      });
  };
};

export const deleteExercise = (id?: any) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteExercise());
    return await ExerciseService.deleteExercise(id)
      .then((res: any) => {
        dispatch(actions.deleteExerciseSuccess({id}));
        dispatch(alertActions.success('Exercise has been deleted successfully!'));
      })
      .catch((err) => {
        dispatch(actions.deleteExerciseFail(err));
        dispatch(alertActions.error('Error'));
      });
  };
};

export const deleteImageExercise = (id?: any) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteImageExercise());
    return await ExerciseService.deleteImageExercise(id)
      .then((res: any) => {
        dispatch(actions.deleteImageExerciseSuccess({id}));
      })
      .catch((err) => {
        dispatch(actions.deleteImageExerciseFail(err));
      });
  };
};